import {Link} from 'react-router-dom';
import {canViewAgentDashboard,canViewAgentWallet} from '../../auth/loginDestination';
import {LayoutDashboard,NotebookPen,Banknote,CircleDollarSign,ChevronDown,Network,Crown,ClipboardCheck,ClipboardList,Siren,Users} from 'lucide-react';
function MobileMenuToggle({onClick,children}){return <Link className="menu" onClick={onClick}>{children}</Link>;}
export default function AdminMobileMenu({MyData,anthScreen,btn,onClickBtn,setHamBnt,location}){
 const agentMenu=false;
 return (
<ul className="scrollable__content py-2">
                            {!agentMenu && canViewAgentDashboard(MyData, anthScreen) && <li><Link to="/agentDashboard" className="menu" onClick={() => setHamBnt(false)}><div className="menu__icon"><LayoutDashboard /></div><div className="menu__title">현황판</div></Link></li>}
                            {MyData?.role === "SUPER" && anthScreen.includes("대시보드") && (
                                <li>
                                    <Link
                                        to={"/dashboard"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <LayoutDashboard />
                                        </div>
                                        <div className="menu__title">대시보드</div>
                                    </Link>
                                </li>
                            )}
                            {!agentMenu && anthScreen.includes("거래내역") && (
                                <li>
                                    <Link
                                        to={"/paylist"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <NotebookPen />
                                        </div>
                                        <div className="menu__title">거래조회</div>
                                    </Link>
                                </li>
                            )}
                            {!agentMenu && canViewAgentWallet(MyData, anthScreen) && (
                                <li>
                                    <Link
                                        to={"/agentWallet"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <Banknote />
                                        </div>
                                        <div className="menu__title">지갑</div>
                                    </Link>
                                </li>
                            )}

                            <li>
                                <MobileMenuToggle agent={agentMenu} expanded={btn[1]} onClick={() => onClickBtn(1)}> 
                                    <div className="menu__icon">
                                        <CircleDollarSign />
                                    </div>
                                    <div className="menu__title">
                                        정산
                                        <i
                                            className={`menu__sub-icon ${btn[1] ? "transform rotate-180" : ""
                                                }`}
                                        >{agentMenu && <ChevronDown size={20}/>}</i>
                                    </div>
                                </MobileMenuToggle>
                                {btn[1] && (
                                    <ul className={`depth_2${agentMenu ? " agent-settlement-menu" : ""}`}>
                                        {/* {MyData?.role === "SUPER" && (
                                            <>
                                                {anthScreen.includes("정산달력") && (
                                                    <li>
                                                        <Link
                                                            to={"/calendar"}
                                                            className="menu side_gnb"
                                                            data-id="calendar"
                                                            onClick={() => setHamBnt(false)}
                                                        >
                                                            <div className="menu__title">월별 달력</div>
                                                        </Link>
                                                    </li>
                                                )}
                                            </>
                                        )} */}
                                        {anthScreen.includes("상세정보") && (
                                            <li>
                                                <Link
                                                    to="/payDetailList"
                                                    aria-current={agentMenu && location.pathname === "/payDetailList" ? "page" : undefined}
                                                    className="menu side_gnb"
                                                    data-id="coins"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__title">승인내역</div>
                                                </Link>
                                            </li>
                                        )}
                                        {anthScreen.includes("가맹점 정산내역") && (
                                            <li>
                                                <Link
                                                    to={"/settlements"}
                                                    aria-current={agentMenu && location.pathname === "/settlements" ? "page" : undefined}
                                                    className="menu side_gnb"
                                                    data-id="calendar"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__title">가맹점 내역</div>
                                                </Link>
                                            </li>
                                        )}
                                        {anthScreen.includes("에이전트 정산내역") && (
                                            <li>
                                                <Link
                                                    to={"/settlementsAgent"}
                                                    aria-current={agentMenu && location.pathname === "/settlementsAgent" ? "page" : undefined}
                                                    className="menu side_gnb"
                                                    data-id="coins"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__title">에이전트 내역</div>
                                                </Link>
                                            </li>
                                        )}

                                    </ul>
                                )}
                            </li>

                            <li>
                                <MobileMenuToggle agent={agentMenu} expanded={btn[3]} onClick={() => onClickBtn(3)}> 
                                    <div className="menu__icon">
                                        <Network />
                                    </div>
                                    <div className="menu__title">
                                        가맹점
                                        <i
                                            className={`menu__sub-icon ${btn[3] ? "transform rotate-180" : ""
                                                }`}
                                        >{agentMenu && <ChevronDown size={20}/>}</i>
                                    </div>
                                </MobileMenuToggle>
                                {btn[3] && (
                                    <ul className="depth_2">
                                        {anthScreen.includes("가맹점") && (
                                            <li>
                                                <Link
                                                    to={"/submerchants"}
                                                    className="menu side_gnb"
                                                    data-id="calendar"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__title">가맹점 관리</div>
                                                </Link>
                                            </li>
                                        )}
                                        {/* {anthScreen.includes("가맹점") && (
                                            <li>
                                                <Link
                                                    to={"/createMerchants"}
                                                    className="menu side_gnb"
                                                    data-id="coins"
                                                    onClick={() => setHamBnt(false)}
                                                >
                                                    <div className="menu__title">가맹점 등록</div>
                                                </Link>
                                            </li>
                                        )} */}
                                    </ul>
                                )}
                            </li>

                            {anthScreen.includes("통합에이전트") && (
                                <li>
                                    <Link
                                        to={"/integrateAgent"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <Crown />
                                        </div>
                                        <div className="menu__title">에이전트</div>
                                    </Link>
                                </li>
                            )}

                            {anthScreen.includes("수기결제") && (
                                <li>
                                    <Link
                                        to={"/sugiManage"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <ClipboardCheck />
                                        </div>
                                        <div className="menu__title">{MyData?.role == "SUPER" ? "수기 결제" : "수기 신청"}</div>
                                    </Link>
                                </li>
                            )}
                            {/* {anthScreen.includes("수기결제취소") && (
                                <li>
                                    <Link
                                        to={"/sugiCancelManage"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <ClipboardX />
                                        </div>
                                        <div className="menu__title">{MyData?.role == "SUPER" ? "수기 취소" : "수기 취소신청"}</div>
                                    </Link>
                                </li>
                            )} */}

                            {anthScreen.includes("수기결제승인내역") && (
                                <li>
                                    <Link
                                        to={"/submerchants"}
                                        className="menu"
                                        onClick={() => setHamBnt(false)}
                                    >
                                        <div className="menu__icon">
                                            <ClipboardList />
                                        </div>
                                        <div className="menu__title">수기 승인/취소</div>
                                    </Link>
                                </li>
                            )}

                            {MyData?.role === "SUPER" && (
                                <>
                                    {anthScreen.includes("수기결제처리내역") && (
                                        <li>
                                            <Link
                                                to={"/sugiHistoryManage"}
                                                className="menu"
                                                onClick={() => setHamBnt(false)}
                                            >
                                                <div className="menu__icon">
                                                    <ClipboardList />
                                                </div>
                                                <div className="menu__title">수기 처리내역</div>
                                            </Link>
                                        </li>
                                    )}
                                </>
                            )}

                            {MyData?.role === "SUPER" && (
                                <li>
                                    <MobileMenuToggle agent={agentMenu} expanded={btn[2]} onClick={() => onClickBtn(2)}> 
                                        <div className="menu__icon">
                                            <Siren />
                                        </div>
                                        <div className="menu__title">
                                            RM
                                            <i
                                                className={`menu__sub-icon ${btn[2] ? "transform rotate-180" : ""
                                                    }`}
                                            >{agentMenu && <ChevronDown size={20}/>}</i>
                                        </div>
                                    </MobileMenuToggle>
                                    {btn[2] && (
                                        <ul className="depth_2">
                                            {anthScreen.includes("RM") && (
                                                <li>
                                                    <Link
                                                        to={"/riskTrx"}
                                                        className="menu side_gnb"
                                                        data-id="admin"
                                                        onClick={() => setHamBnt(false)}
                                                    >
                                                        <div className="menu__title">이상 거래 관리</div>
                                                    </Link>
                                                </li>
                                            )}
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link
                                                        to={"/riskQuotaManage"}
                                                        className="menu side_gnb"
                                                        data-id="admin"
                                                        onClick={() => setHamBnt(false)}
                                                    >
                                                        <div className="menu__title">할부 관리</div>
                                                    </Link>
                                                </li>
                                            )} */}
                                            {/* {anthScreen.includes("할부관리") && (
                                                <li>
                                                    <Link
                                                        to={"/riskBlackListManage"}
                                                        className="menu side_gnb"
                                                        data-id="admin"
                                                        onClick={() => setHamBnt(false)}
                                                    >
                                                        <div className="menu__title">블랙리스트카드</div>
                                                    </Link>
                                                </li>
                                            )} */}
                                        </ul>
                                    )}
                                </li>
                            )}

                            {MyData?.role === "SUPER" && (
                                <li>
                                    <MobileMenuToggle agent={agentMenu} expanded={btn[5]} onClick={() => onClickBtn(5)}> 
                                        <div className="menu__icon">
                                            <Users />
                                        </div>
                                        <div className="menu__title">
                                            관리자
                                            <i
                                                className={`menu__sub-icon ${btn[5] ? "transform rotate-180" : ""
                                                    }`}
                                            >{agentMenu && <ChevronDown size={20}/>}</i>
                                        </div>
                                    </MobileMenuToggle>
                                    {btn[5] && (
                                        <ul className="depth_2">
                                            {anthScreen.includes("관리자 조회") && (
                                                <li>
                                                    <Link
                                                        to={"/admin"}
                                                        className="menu side_gnb"
                                                        data-id="admin"
                                                        onClick={() => setHamBnt(false)}
                                                    >
                                                        <div className="menu__title">관리자 조회</div>
                                                    </Link>
                                                </li>
                                            )}
                                            {anthScreen.includes("수익 정산") && (
                                                <li>
                                                    <Link
                                                        to={"/profitSettlement"}
                                                        className="menu side_gnb"
                                                        data-id="admin"
                                                        onClick={() => setHamBnt(false)}
                                                    >
                                                        <div className="menu__title">수익 정산</div>
                                                    </Link>
                                                </li>
                                            )}
                                            {anthScreen.includes("수수료안내") && (
                                                <li>
                                                    <Link
                                                        to={"/feeNotice"}
                                                        className="menu side_gnb"
                                                        data-id="admin"
                                                        onClick={() => setHamBnt(false)}
                                                    >
                                                        <div className="menu__title">수수료안내</div>
                                                    </Link>
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </li>
                            )}
                            
                        </ul>
 );
}
